import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";

const offers = [
  {
    id: "one_time_99",
    slug: "pack-99",
    badge: "ONE-TIME",
    name: "1 Week Done For You Content Pack",
    price: 99.99,
    period: "one time",
    pitch: "Test the water. Get a week of content for less than a dinner out.",
    features: [
      "5 professional short-form videos",
      "5 branded social images",
      "Custom to your brand & niche",
      "72–96 hour turnaround (depending on project size)",
      "Delivered via Google Drive",
      "All sales final. One revision per order.",
    ],
    cta: "Get the $99.99 Pack",
    highlighted: false,
  },
  {
    id: "monthly_175",
    slug: "monthly-175",
    badge: "MOST POPULAR",
    name: "Done For You Monthly Content Plan",
    price: 175,
    period: "per month",
    pitch: "Fresh content every 30 days. Cancel any time you want.",
    features: [
      "10 short-form videos per month",
      "10 branded images per month",
      "Tailored to your brand voice",
      "Delivered every 30 days",
      "Priority 72–96 hour turnaround",
      "Cancel anytime. No refunds for paid cycles.",
    ],
    cta: "Start Monthly Plan",
    highlighted: true,
  },
];

export const OfferCards = ({ inline }) => {
  return (
    <section className={`${inline ? "" : "py-20 md:py-28"}`} data-testid="offers-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        {!inline && (
          <div className="text-center mb-12">
            <span className="pill" data-testid="offers-pill">Pick Your Plan</span>
            <h2 className="mt-5 font-display font-bold text-white text-4xl sm:text-5xl tracking-tighter">
              Two ways to win. <span className="text-[#3B9EFF]">Both stupid simple.</span>
            </h2>
          </div>
        )}
        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {offers.map((o) => (
            <div
              key={o.id}
              className={`snap-card flex flex-col ${o.highlighted ? "border-[#3B9EFF]/60 shadow-[0_0_40px_rgba(59,158,255,0.12)]" : ""}`}
              data-testid={`offer-card-${o.slug}`}
            >
              <div className="flex items-center justify-between">
                <span className="pill text-[10px]" data-testid={`offer-badge-${o.slug}`}>{o.badge}</span>
                {o.highlighted && <span className="font-accent text-xs text-[#3B9EFF]">★ Best Value</span>}
              </div>
              <h3 className="mt-5 font-display text-2xl md:text-3xl font-bold text-white tracking-tight">{o.name}</h3>
              <p className="mt-2 text-[#A0AABF] text-sm">{o.pitch}</p>
              <div className="mt-6 flex items-baseline gap-2">
                <span className="font-display font-black text-5xl text-white">${o.price}</span>
                <span className="text-[#A0AABF] text-sm">/ {o.period}</span>
              </div>
              <ul className="mt-6 space-y-3">
                {o.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-3 text-white/90">
                    <span className="mt-0.5 w-5 h-5 rounded-full bg-[#3B9EFF]/15 border border-[#3B9EFF]/40 flex items-center justify-center text-[#3B9EFF] shrink-0">
                      <Check size={12} />
                    </span>
                    <span className="text-sm">{f}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-8 flex flex-col gap-3">
                <Link
                  to={`/offer/${o.slug}`}
                  className="btn-primary w-full justify-center"
                  data-testid={`offer-buy-${o.slug}`}
                >
                  {o.cta}
                  <ArrowRight size={18} />
                </Link>
                <p className="text-center text-xs text-[#A0AABF]">
                  Terms applied at checkout. All sales final.
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OfferCards;

